import { Box } from '@mui/material';
import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  value: string | number;
  selected?: boolean;
  index?: number;
  idPrefix?: string;
  vertical?: boolean;
  [key: string]: any;
}

const TabPanel = (props: TabPanelProps) => {
  const {
    children,
    value,
    selected,
    index,
    idPrefix = 'tab',
    vertical = false,
    ...other
  } = props;

  // Handle both string-based and number-based tab values
  let isSelected = false;
  if (selected !== undefined) {
    isSelected = selected;
  } else if (index !== undefined) {
    isSelected = value === index;
  }

  const panelId = index !== undefined
    ? `${idPrefix}-tabpanel-${index}`
    : `${idPrefix}-tabpanel-${value}`;
  const ariaLabelledBy = index !== undefined
    ? `${idPrefix}-tab-${index}`
    : `${idPrefix}-tab-${value}`;

  return (
    <div
      role="tabpanel"
      hidden={!isSelected}
      id={panelId}
      aria-labelledby={ariaLabelledBy}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    >
      {isSelected && (
        <Box sx={vertical ? { height: '100%', overflow: 'auto' } : { p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel; 